enum UserType {
  OPERATOR = 'operator',
  ADMIN = 'admin',
}

export default UserType;
